export const APP_NAME = 'Dylan McDonald';
export const HELLO_PAGE_TITLE = 'Hello';
export const HELLO_PAGE_DESCRIPTION =
  "Twin Cities based full-stack developer. Lead developer at bswing. Let's work together to actualize ideas.";
export const CONTACT_PAGE_TITLE = 'Contact';
export const CONTACT_PAGE_DESCRIPTION =
  "Twin Cities based full-stack developer. Lead developer at bswing. Let's work together to actualize ideas.";
